import styled from 'styled-components'

export const Boton = styled.button`
  color: #ffffff !important;
  background-color: #1d873e;
  font-size: 16px;
  min-width: 200px;
  min-height: 56px;
  transition: all 0.3s ease;
  margin-left: 20px;
  @media (max-width: 768px) {
    min-width: 80px;
    min-height: 32px;
  }
  border:none;
`

export const BotonCard = styled.button`
  color: #ffffff !important;
  background-color: #1d873e;
  margin: 0px 15px 0 8px;
  font-size: 13px;
  min-width: 150px;
  min-height: 50px;
  transition: all 0.3s ease;
  border: 0px
`
export const BotonCardMini = styled.button`
  color: #ffffff !important;
  background-color: #1d873e;
  margin: 0px 15px 0 8px;
  font-size: 12px;
  min-width: 100px;
  min-height: 40px;
  transition: all 0.3s ease;
  border: 0px
`
export const BotonCirculo = styled.button`
  font-size: 20px;
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 100px;
  outline: none;
  background: #b71540;
  color: white;
  cursor: pointer;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.15);
`

export const BotonPDF = styled.button`
  color: red;
  background-color: #f3f3f3;
  border-color: #D60D3D;
  border-style: solid;
  border-width: 1px;
  font-weight: bold;
  font-size: 20px;
  margin: 0px 0 0 8px;
  transition: all 0.3s ease;
  border-radius: 5px;
`
